import React from "react";
import {
  Card,
  Modal,
  Icons,
  Grid,
  Text,
  ProgressBar,
  Button,
  CircleIconButton,
  Divider,
} from "@pushpress/shared-components";
import uniq from "lodash/uniq";
import { getMemberLength, getMemberLastVisit, getRiskInfo } from "./utils";
import styles from "./ChurnReport.module.scss";

type ChurnReportModalProps = {
  churnReport: any;
  visible: boolean;
  onClose: VoidFunction;
};

function ChurnReportModal(props: ChurnReportModalProps) {
  const { visible, onClose } = props;

  return (
    <Modal visible={visible} closeModal={onClose}>
      <ChurnReportContent {...props} />
    </Modal>
  );
}

function ChurnReportContent({ churnReport, onClose }: ChurnReportModalProps) {
  if (!churnReport) return <></>;

  const { riskLabel, riskColor } = getRiskInfo(churnReport.churnProbability);

  return (
    <div className={styles.card}>
      <Card>
        <Card.Cover backgroundColor="#0063FF">
          <div className={styles.close}>
            <Icons.X onClick={onClose} />
          </div>
          <Text variant="heading-1" color="white">
            {churnReport.name}
          </Text>
        </Card.Cover>
        <Grid container>
          <Grid item xs={12}>
            <Grid
              container
              paddingY={3}
              paddingX={2}
              spacing={0}
              columnSpacing={0}
            >
              <Grid item xs={6}>
                <Text variant="body-md">Churn probability</Text>
              </Grid>
              <Grid item xs={6}>
                <Text variant="body-md">
                  <ProgressBar
                    label={riskLabel}
                    color={riskColor}
                    progressWidth={Math.round(
                      Number(churnReport.churnProbability) * 100,
                    )}
                  />
                </Text>
              </Grid>
            </Grid>
            <Divider />
            <Grid
              container
              paddingY={3}
              paddingX={2}
              spacing={0}
              columnSpacing={0}
            >
              <Grid item xs={6}>
                <Text variant="body-md">Prediction reasons</Text>
              </Grid>
              <Grid item xs={6}>
                {uniq(churnReport.reasons).map(({ reason }, key) => (
                  <React.Fragment key={key}>
                    <Text variant="body-md" color="black">
                      {reason}
                    </Text>
                    {key !== churnReport.reasons.length - 1 && <br />}
                  </React.Fragment>
                ))}
              </Grid>
            </Grid>
            <Divider />
            {churnReport.memberSince && (
              <Grid
                container
                paddingY={3}
                paddingX={2}
                spacing={0}
                columnSpacing={0}
              >
                <Grid item xs={6}>
                  <Text variant="body-md">Member length</Text>
                </Grid>
                <Grid item xs={6}>
                  <Text variant="body-md" color="black">
                    {getMemberLength(
                      new Date(),
                      new Date(churnReport.memberSince),
                    )}
                  </Text>
                </Grid>
              </Grid>
            )}
            <Divider />
            <Grid
              container
              paddingY={3}
              paddingX={2}
              spacing={0}
              columnSpacing={0}
            >
              <Grid item xs={6}>
                <Text variant="body-md">Last visit since</Text>
              </Grid>
              <Grid item xs={6}>
                <Text variant="body-md" color="black">
                  {getMemberLastVisit(churnReport.lastVisit)}
                </Text>
              </Grid>
            </Grid>
            <Divider />
            <Grid
              container
              alignItems="center"
              justifyContent="center"
              columnSpacing={0}
              marginY={5}
            >
              <Grid item xs="auto">
                <CircleIconButton
                  icon={Icons.User}
                  tooltip={"View Profile"}
                  color={"#0063FF"}
                  onClick={() => {
                    window.location.href = `/members/view/${churnReport.userUuid}`;
                  }}
                />
              </Grid>
            </Grid>
            <Grid container columnSpacing={0} paddingX={3} marginY={2}>
              <Grid item xs={12}>
                <Card>
                  <Card.Content>
                    <Grid container>
                      <Grid item xs={2}>
                        <Icons.Help />
                      </Grid>
                      <Grid item xs={10}>
                        <Text variant="body-md">
                          Learn how to read this churn probability and whats
                          behind Pressly our Artificial Intellegence engine to
                          calculate these predictions.
                        </Text>
                        <Button
                          text="Learn More"
                          buttonType="text"
                          icon={Icons.NewPage}
                          iconLocation="right"
                          href="https://help.pushpress.com/en/articles/6708070-core-churn-report"
                          target="_blank"
                        />
                      </Grid>
                    </Grid>
                  </Card.Content>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </div>
  );
}

export default ChurnReportModal;
